import Vue from 'vue'

// This is still rendered by the Rails layout outside the main vue app component,
// so we need it registered globally here.
import Messages from './messages/messages.vue'
Vue.component('messages', Messages)
